import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NewsCard from '../components/NewsCard';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Loader2, BookmarkX } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Bookmarks = () => {
  const { getAuthHeader } = useAuth();
  const { t } = useLanguage();
  const [bookmarks, setBookmarks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBookmarks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/bookmarks`, {
        headers: getAuthHeader()
      });
      setBookmarks(response.data);
    } catch (error) {
      console.error('Error fetching bookmarks:', error);
      toast.error('Failed to load bookmarks');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const handleBookmarkToggle = async (newsId) => {
    try {
      await axios.delete(`${API}/bookmarks/${newsId}`, {
        headers: getAuthHeader()
      });
      toast.success('Bookmark removed');
      fetchBookmarks();
    } catch (error) {
      toast.error('Failed to remove bookmark');
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFDF5]">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-12">
          <h1 className="text-5xl md:text-7xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            {t('bookmarks.title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('bookmarks.subtitle')}
          </p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-[#FF6B6B]" strokeWidth={2.5} />
          </div>
        ) : bookmarks.length === 0 ? (
          <div className="text-center py-20">
            <BookmarkX className="w-16 h-16 mx-auto mb-4 text-gray-400" strokeWidth={2} />
            <p className="text-xl text-gray-600" data-testid="no-bookmarks-message">
              {t('bookmarks.empty')}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="bookmarks-grid">
            {bookmarks.map((item) => (
              <NewsCard
                key={item.id}
                news={item}
                onBookmarkToggle={handleBookmarkToggle}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Bookmarks;